var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "note-body" }, [
    _vm.collapsible &&
    _vm.expand &&
    !_vm.options.expandNotes &&
    _vm.noteText &&
    (_vm.noteText.length > 500 || _vm.newLines() > 10)
      ? _c("div", [
          _c(
            "a",
            {
              staticClass: "full-note-toggle",
              on: { click: _vm.toggleFullNote }
            },
            [_vm._m(0)]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { domProps: { innerHTML: _vm._s(_vm.formattedNote) } }),
    _vm._v(" "),
    _vm.collapsible &&
    !_vm.options.expandNotes &&
    _vm.noteText &&
    (_vm.noteText.length > 500 || _vm.newLines() > 10)
      ? _c("div", [
          _c(
            "a",
            {
              staticClass: "full-note-toggle",
              on: { click: _vm.toggleFullNote }
            },
            [
              _vm.expand
                ? _c("span", [
                    _c("i", { staticClass: "fa fa-minus" }),
                    _vm._v("Hide")
                  ])
                : _c("span", [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v("Show")
                  ]),
              _vm._v("\n            Full Note\n        ")
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "fa fa-minus" }),
      _vm._v("Hide Full Note")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d980053", { render: render, staticRenderFns: staticRenderFns })
  }
}